module.exports = __webpack_public_path__ + "img/get-app.ca48d12.svg";